var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',_vm._g(_vm._b({attrs:{"icon":"","small":_vm.small,"color":_vm.color}},'v-btn',_vm.$attrs,false),_vm.$listeners),[_c('v-icon',{attrs:{"small":_vm.small}},[_vm._v(_vm._s(_vm.icon))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }